<template>
  <el-dialog
          class="purchaseBox"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="480px"
          :append-to-body="true"
          :show-close="false"
          :custom-class="'purchaseWrapper'"
          :modal-append-to-body="false"
          :close-on-press-escape="false"
          :lock-scroll="false"
          @open="onOpenDialog"
          @close="handleClose"
          :destroy-on-close="true"
  >
    <div class="purchaseModalMain">
      <i class="closeIcon el-icon-close" @click="onClickClose"></i>
      <img src='@/assets/img/retentionPopBg.png' alt='' class='popBg'>
      <div class="title">{{titleTxt}}</div>
      <div class="contentBox">
        <span class="weight">{{purchaseTitle}}</span>
        <span class="priceBtn">
          <span class="unit">¥</span>
          <span>{{price}}</span>
        </span>
      </div>
      <span class="price">
        <span class="unit">¥</span>
        <span>{{price}}</span>
      </span>
      <div class="descList">
        <div class="listItem"><span class="icon"></span>不限下载次数</div>
        <div class="listItem"><span class="icon"></span>畅享全站功能</div>
      </div>
      <div class="payTitle">扫码立即开通</div>
      <div class="payChannelBox">
        <span class="wechat_icon"></span>
        <span class="ali_icon"></span>
        <span>扫码支付</span>
      </div>
      <div class='qrCodeBox'>
        <img :src="qrCodeSrc" alt="" class="qrCodeImg" v-if="!loading" />
        <div class="loading" v-else>
          <img src="@/assets/img/loading.png" alt="" class="loadingImg" />
        </div>
      </div>
      <div class='closeBtn' @click='handleClose'>放弃机会</div>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import QRCode from 'qrcode'
import { createOrder, getPayStatus } from '@/api'
import { Message, MessageBox } from "element-ui";
import { uploadPayData } from '../../utils/baiduOCPC'

export default {
  name: 'RetentionModal',
  components: {},
  data() {
    return {
      loading: false,
      qrCodeSrc: '',
      price: 0,
      pollCount: 0, // 轮询次数
      payResultTimer: null,
      titleTxt: '', //
      purchaseTitle: ''
    }
  },
  computed: {
    ...mapState(['isRetentionModalVisible']),
    ...mapGetters(['isVip', 'isCountVIP']),
    dialogVisible() {
      return this.isRetentionModalVisible
    }

  },
  methods: {
    ...mapActions(['hideRetentionModal']),
    // 获取商品信息
    async getPurchase() {
      if (this.isCountVIP) {
        this.titleTxt = '限时福利 一次购买终身使用'
        this.purchaseTitle = '终身会员'
        await this.checkPurchase(5, 39)
      } else {
        this.titleTxt = '还在犹豫？先体验一下'
        this.purchaseTitle = '3天体验VIP'
        await this.checkPurchase(11, 19.9)
      }

    },
    /**
     * @description 转换二维码
     * @param path 路径信息
     * @returns {Promise<unknown>}
     */
    async toQRCode(path) {
      return QRCode.toDataURL(path)
    },
    /**
     * @description 轮询，获取支付状态
     * @param orderId 订单ID
     */
    lookup(orderId) {
      clearTimeout(this.payResultTimer)

      if (this.pollCount > 5000) {
        // 支付超时
        this.hideRetentionModal()
        return
      }

      this.payResultTimer = setTimeout(async () => {
        let r = await getPayStatus(orderId)
        if (r.data.status === 0 && r.data.data.order.status === 1) {
          // 查询成功 并且 状态为1 或者支付超时
          await this.$store.dispatch('updateUserInfo')

          Message({
            type: 'success',
            message: '支付成功'
          })
          await this.hideRetentionModal()
          // FIXME: 浮点数精度丢失，可以采用第三方库处理，也可以后端处理
          uploadPayData(Math.ceil(this.price * 100)).catch(e => {})

          clearTimeout(this.payResultTimer)
        } else {
          this.lookup(orderId)
        }
      }, 1500)

      this.pollCount++ // 增加轮询次数
    },
    onClickClose() {
      MessageBox.confirm('您目前拥有优惠购买特权，退出后将无法享用?', '温馨提示', {
        confirmButtonText: '继续支付',
        cancelButtonText: '确定放弃',
        customClass: 'my_dialog',
        type: 'warning',
        showClose: false
      }).then(() => {

      }).catch(() => {
        this.handleClose()
      })
    },
    /**
     * @description 切换套餐
     * @param idx 选中的索引
     * @returns {Promise<void>}
     */
    async checkPurchase(id, price) {
      this.loading = true
      this.price = price
      let res = await createOrder(id)
      if (res.data.status === 0) {
        let src = await this.toQRCode(res.data.data)
        this.qrCodeSrc = src
        this.loading = false
        this.pollCount = 0 // 清空轮询次数
        let s = res.data.data.split('/')
        let orderId = s[s.length - 1]
        this.lookup(orderId)
      } else {
        // 二维码获取失败
      }
    },
    /**
     * @description 关闭窗口
     */
    handleClose() {
      clearInterval(this.payResultTimer)
      this.hideRetentionModal()
    },
    /**
     * @description 打开窗口
     */
    onOpenDialog() {
      this.getPurchase()
    }
  }
}
</script>
<style scoped lang="less">
@import './index.less';
</style>
